
import React, { useState } from 'react'
import VisDiv from '../../../whitaijiFrontendLibrary/components/VisDiv';
import { CiCircleCheck } from "react-icons/ci";
import { HiCheckCircle } from "react-icons/hi2";
export const CheckBox = ({
  data={}, 
  label, 
  objKey, 
  defaultValue = false, 
  isError = false,
  errorMessage,
  onBlur,
  onChange
}) => {
    const {doc, setDoc} = data
    const [value, setValue] = useState(doc[objKey] ? doc[objKey] : defaultValue)
    if(!objKey) return <p>No objKey</p>
    return (
      <div>
        <div 
          onClick={() => {
            const newValue = !value;
            setValue(newValue);
            setDoc({...doc, [objKey]: newValue});
            if (newValue) {
              // If checked, clear error state immediately
              onChange?.(newValue);
            } else {
              // If unchecked, validate through blur
              onChange?.(newValue);
              onBlur?.();
            }
          }} 
          style={{
            alignItems: "center",
            border: isError ? '1px solid #ff0000' : 'none',
            borderRadius: '4px',
            padding: '4px'
          }} 
          className="radio-button-container"
        >
          <VisDiv className="flex-center" rules={[!value]}>
              <CiCircleCheck size={24} style={{ color: isError ? '#ff0000' : 'inherit' }} />
          </VisDiv>  
          <VisDiv className="flex-center" rules={[value]}>
              <HiCheckCircle size={24} style={{ color: isError ? '#ff0000' : 'inherit' }} />
          </VisDiv> 
          <div style={{marginLeft:"10px", color: isError ? '#ff0000' : 'inherit'}} >
            {label} 
          </div>
        </div>
        {isError && errorMessage && (
          <div style={{
            color: '#ff0000',
            fontSize: '12px',
            marginTop: '4px',
            marginLeft: '28px'
          }}>
            {errorMessage}
          </div>
        )}
      </div>
    )
  }
